(function(){
    'use strict';

    angular
        .module('app')
        .controller('FaqController', FaqController);

    function FaqController(API) {
        let vm = this;

        vm.cardsFaq = [];
        vm.activeDetailsIndex = null;
        vm.currentPage = 1;
        
        vm.submitFaq = (Faq) => {
			API.post(`faq`, Faq)
		   .then(result => console.log(result))
		   .then(() => {
			   angular.copy({}, Faq)
			   vm.ItsOkayForm.$submitted = false;
			   vm.ItsOkayForm.$setPristine();
		   })
		   .catch(error => {
			 console.log(error, 'error');
			 swal({title: 'Opss...!', text: 'Tente novamente!', type: 'error'}).then(() => $state.reload());
		   });
        }

        vm.showDetails = function(index){
        	if(index == vm.activeDetailsIndex){
        		vm.activeDetailsIndex = null
        	}else{
        		vm.activeDetailsIndex = index
        	}
        }

        vm.toTop = function(){
        	$('html, body').animate({
	          scrollTop: 0
	      	}, 'fast');
	      	vm.activeDetailsIndex = null;
        }

		vm.$onInit = () => {
		  _loadFromApi();
		}

		function _loadFromApi() {
		  _loadFaq();
		}

		function _loadFaq() {
		  API.get(`servico`)
				.then(result => result.data)
				.then(faq => vm.cardsFaq = faq)
				.catch(error => {
				  console.log(error, 'error');
				});
		}
    }

})();
